import Vue from 'vue';
import Config from './Config';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueLodash from 'vue-lodash';
import VueMask from 'v-mask'
import lodash from 'lodash';
import AsyncComputed from 'vue-async-computed';
import { sync } from 'vuex-router-sync';

Vue.config.productionTip = false;

Vue.use(VueMask);
Vue.use(AsyncComputed)
// enable lodash from anywhere in the app with this._ or this.lodash
Vue.use(VueLodash, { lodash: lodash });

sync(store, router);

const app = new Vue({
	router,
	store,
	vuetify,
	render: function (h) { return h(Config); }
}).$mount('#qvo-config-app');

app.name = 'Config';
